// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3eXr9","productName":"Table_productName__2CyLc"};